/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetK12DistrictQueryResponse,
  GetK12DistrictPathParams,
  GetK12District404,
} from '../types/GetK12District'

function getGetK12DistrictUrl({ id }: { id: GetK12DistrictPathParams['id'] }) {
  const res = { method: 'GET', url: `/api/v1/k12/districts/${id}/` as const }
  return res
}

/**
 * @summary Get K-12 district detail
 * {@link /api/v1/k12/districts/:id/}
 */
export async function getK12District(
  { id }: { id: GetK12DistrictPathParams['id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetK12DistrictQueryResponse,
    ResponseErrorConfig<GetK12District404>,
    unknown
  >({
    method: 'GET',
    url: getGetK12DistrictUrl({ id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
